import { ProviderStatusEnum } from '../Enum/ProviderStatusEnum';

export const isHiddenProviderStatus = (status?: ProviderStatusEnum | number | null) => {
    return status === ProviderStatusEnum.Inactive || status === ProviderStatusEnum.Suspended;
};

export const providerDropdownColor = (status?: ProviderStatusEnum | number | null) => {
    return isHiddenProviderStatus(status) ? 'grey' : 'black';
};
